module.exports = __webpack_public_path__ + "static/media/bg51.21719d46.png";